const View = require('public_framework/view')

module.exports = class Event extends View {
  get events () {
    return {
      'mouseover': 'handleItemMouseover',
      'mouseleave': 'handleItemMouseleave'
    }
  }

  handleItemMouseover (e) {
    this.emit('map:activate_marker', this.$el.data('location'))
  }

  handleItemMouseleave (e) {
    this.emit('map:deactivate_marker', this.$el.data('location'))
  }
}



// WEBPACK FOOTER //
// ./front/apps/public/pages/community/javascripts/views/event.js